module.exports = __webpack_public_path__ + "img/3.32d1844b.png";